import React from 'react';
import { Flex } from '@chakra-ui/react';
import CircularProgress from '../Data/CircularProgress';

const HeaderProgress = React.memo(function ({
 totalAnsweredQuestions,
 totalQuestions,
 requiredQuestions,
 answeredRequiredQuestions,
 totalIndicators = 0,
 answeredIndicators = 0,
}) {
 const requiredProgress =
  requiredQuestions === 0 ? 0 : (answeredRequiredQuestions / requiredQuestions) * 100;

 return (
  <Flex gap='60px' display={['none', 'flex']} justify='center' h='101.5px'>
   <CircularProgress
    name='Respondidas'
    label={`${totalAnsweredQuestions}/${totalQuestions}`}
    value={(totalAnsweredQuestions / totalQuestions) * 100}
    color='#0073BB'
   />
   <CircularProgress
    name='Obrigatórias'
    label={`${answeredRequiredQuestions}/${requiredQuestions}`}
    value={requiredProgress}
    color='#EA582B'
   />
   {/* GRI-07: indicador é MEDIDA da questão, não questão. Contagem própria,
       só aparece em questionário que tem indicador. */}
   {totalIndicators > 0 && (
    <CircularProgress
     name='Indicadores'
     label={`${answeredIndicators}/${totalIndicators}`}
     value={(answeredIndicators / totalIndicators) * 100}
     color='#1B5E30'
    />
   )}
  </Flex>
 );
});

export default HeaderProgress;
